import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import PageSection from '../components/PageSection';
import { Header2, Paragraph } from '../components/Typography';
import {
  ssColorCyan,
  mainFontFamily,
  mediaBreakpointUpMD,
} from '../constants/style-constants';
import { vunit } from '../lib/style-helpers';

const cardCss = css`
  display: block;
  text-align: center;

  ${mediaBreakpointUpMD} {
    text-align: left;
  }
`;

const headerCss = css`
  color: white;
  margin: 0 0 ${vunit()};
`;

const headerIntroCss = css`
  color: white;
  display: block;
  font-family: ${mainFontFamily};
  font-size: 1rem;
  margin-bottom: ${vunit(3)};
`;

const headerTitleCss = css`
  color: white;
  font-size: 1.6rem;

  ${mediaBreakpointUpMD} {
    font-size: 2rem;
  }
`;

const descriptionCss = css`
  color: white;
  margin: 0 0 ${vunit(2)};
`;

const linkCss = css`
  color: ${ssColorCyan};
  font-weight: bold;
  text-transform: uppercase;
`;


const RoleCardSection = ({
  intro, roleTitle, roleDescription, link,
}) => (
  <PageSection theme="blue">
    <a css={cardCss} href={link.path}>
      <div className="row">
        <div className="col-md-6">
          <Header2 css={headerCss}>
            <span css={headerIntroCss}>{intro}</span>
            <span css={headerTitleCss}>{roleTitle}</span>
          </Header2>
        </div>
        <div className="col-md-6">
          <Paragraph css={descriptionCss}>{roleDescription}</Paragraph>
          <span css={linkCss}>{link.text}</span>
        </div>
      </div>
    </a>
  </PageSection>
);

RoleCardSection.propTypes = {
  intro: PropTypes.string.isRequired,
  roleTitle: PropTypes.string.isRequired,
  roleDescription: PropTypes.string.isRequired,
  link: PropTypes.shape({
    path: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
  }).isRequired,
};

export default RoleCardSection;
